import React from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import ExpansionPanelTitleAvatar from "components/ExpansionPanelTitleAvatar";
import {getSectionVariant} from "../../constants/StageSections";


function OfferExpansionSectionTitle(
    {
        section
    }) {

    return (
        <GridBlock alignItems="center">
            <ExpansionPanelTitleAvatar variant={getSectionVariant(section)}/>
            <Typography variant='h6'>
                {section.name}
            </Typography>
        </GridBlock>
    )

}

OfferExpansionSectionTitle.propTypes = {
    expanded: PropTypes.bool.isRequired,
    section: PropTypes.shape({
        section: PropTypes.string.isRequired
    }).isRequired
}

export default OfferExpansionSectionTitle;